var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapitecPayColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 119,
    viewBox: "0 0 283 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4999,
    y: 17.5002,
    width: 225,
    height: 83,
    rx: 41.5,
    fill: "white",
    stroke: "#0033A0",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.78 39.24H77.59V50.94C77.59 55.01 80.92 58.32 84.99 58.32H99.21C104.3 58.32 108.46 62.75 108.46 67.85V78.92C118.32 77.29 125.87 68.69 125.87 59.1C125.87 48.34 116.37 39.24 104.77 39.24H104.78Z",
    fill: "#E61414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.52 59.73H79.35C74.26 59.73 70.09 55.63 70.09 50.54V39.24C59.08 39.87 50.29 48.7 50.29 59.06C50.29 69.42 59.79 78.92 71.39 78.92H100.92V67.14C100.92 63.07 97.59 59.73 93.51 59.73",
    fill: "#00486D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.685 79V39.785H160.515C168.655 39.785 173.99 44.57 173.99 52.27C173.99 58.43 170.03 64.865 160.79 64.865H152.21V79H143.685ZM152.21 57.99H159.25C163.155 57.99 165.63 55.955 165.63 52.38C165.63 48.365 162.99 46.715 159.195 46.715H152.21V57.99ZM185.243 79.605C179.578 79.605 175.563 76.47 175.563 71.08C175.563 64.975 181.613 62.06 187.223 62.06H193.493V59.64C193.493 57 191.733 55.68 188.543 55.68C185.628 55.68 183.868 56.89 183.868 58.595V59.475H176.828V58.595C176.828 52.38 182.878 49.905 188.818 49.905C195.308 49.905 201.358 52.27 201.358 59.365V72.785C201.358 74.545 201.633 78.395 201.853 79H194.208L193.933 76.085H193.768C191.348 79 188.543 79.605 185.243 79.605ZM187.938 73.665C192.283 73.665 193.493 71.41 193.493 68.55V67.065H188.048C185.243 67.065 183.373 67.945 183.373 70.365C183.373 72.455 184.968 73.665 187.938 73.665ZM209.98 89.725C208.935 89.725 207.34 89.56 206.13 89.285V82.96C207.34 83.18 208.495 83.29 209.485 83.29C211.135 83.29 212.235 82.355 212.675 81.145L213.665 78.45L203.16 50.455H211.685L217.845 69.155H218.01L224.005 50.455H231.705L220.045 82.85C218.285 87.91 214.545 89.725 209.98 89.725Z",
    fill: "#0033A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitecPayColour);
export default __webpack_public_path__ + "static/media/CapitecPay - colour.cfaea0838c32cd74302b90f9366e63ed.svg";
export { ForwardRef as ReactComponent };